import { defineStore } from "pinia";
import { bootstrapService } from "@/api/bootstrap.service";

export const useBootstrapStore = defineStore("bootstrap", {
  state: () => ({
    default_language: null,
    languages: [],
    participant_language_used: null,
    loaded: false,
  }),
  actions: {
    async fetchBootstrap(distributionId, participantTimepointId) {
      try {
        const response = await bootstrapService.fetchBootstrap(
          distributionId,
          participantTimepointId,
        );

        // Check if response and response.data exist before accessing properties
        if (response) {
          this.default_language = response.default_language;
          this.languages = response.languages;
          this.participant_language_used = response.participant_language_used;
          this.loaded = true;
        } else {
          // Handle cases where response or response.data is missing
          console.error("Bootstrap data is missing or invalid:", response);
          this.reset(); // Optionally clear state on error
          // Potentially throw an error or handle it based on application logic
          throw new Error("Failed to load bootstrap data.");
        }
      } catch (error) {
        console.error("Error fetching bootstrap data:", error);
        this.reset(); // Clear state on error
        // Re-throw the error or handle it as needed
        throw error;
      }
    },
    reset() {
      this.languages = [];
      this.default_language = null;
      this.participant_language_used = null;
      this.loaded = false;
    },
  },
});
